import styled from 'styled-components';
import { baseTheme } from '../../../../global/styles/theme';

export const AllReceiptsBlock = styled('div')`
  width: 100%;
  height: fit-content;
  overflow: auto;
  /* Респонсивная сетка: 2 столбца на десктопе, 1 на мобильных */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;

  .not-available-receipts {
    font-weight: 500;
    color: ${baseTheme.colors.mainLightBlue};
    font-size: 18px;
    margin: 0;
    grid-column: 1 / -1; /* Занимает всю ширину сетки */
  }

  .receipt-item {
    border: 1px solid ${baseTheme.colors.focus};
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
    min-width: 0; /* Предотвращает переполнение в grid */
    &:hover {
      background-color: ${baseTheme.colors.focus};
      color: ${baseTheme.colors.white};
    }

    .receipt-item-title {
      margin: 0;
      font-size: 18px;
    }

    .receipt-item-product {
      margin-bottom: 3px;
    }
  }

  /* На мобильных устройствах - 1 столбец */
  @media only screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    padding: 0 10px;
  }

  @media only screen and (max-width: 1024px) {
    width: 100%;
    overflow: auto;
  }
`;
